<div>
    <div [hidden]="!loader" class="loading-data">
        <div>
            <div [hidden]="!loader" class="loading-data">
                <div id="loader">

                    <div id="spinner-back">


                    </div>
                    <div id="spinner">
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>



